// assets
import {
  Home3,
  TruckFast,
  Calendar,
  Map,
  ClipboardText,
  ClipboardTick,
  Clock,
  People,
  Profile2User,
  Setting2,
  Receipt2,
  Bank,
  Setting3,
  Box1,
  Cpu,
  Chart2,
  MoneyRecive,
  MessageQuestion
} from 'iconsax-reactjs';

// types
import { NavItemType } from 'types/menu';

const icons = {
  dashboard: Home3,
  workOrders: ClipboardText,
  fleet: TruckFast,
  calendar: Calendar,
  map: Map,
  customers: People,
  users: Profile2User,
  settings: Setting2,
  invoice: Receipt2,
  paymentDetails: Bank,
  maintenance: Setting3,
  workLogs: Clock,
  payRates: MoneyRecive,
  maintenanceConfig: Setting2,
  inspectionTemplate: ClipboardTick,
  warehouse: Box1,
  sensors: Cpu,
  analytics: Chart2,
  support: MessageQuestion
};

const vektra: NavItemType = {
  id: 'vektra',
  title: 'menu.workspace',
  type: 'group',
  children: [
    // NAV-01 (VEK-93) — the Home entry keeps its historical id `dashboard` (and its MENU_ACCESS row); only its
    // target and English label changed when the reporting page moved to /analytics.
    { id: 'dashboard', title: 'menu.dashboard', type: 'item', url: '/home', icon: icons.dashboard, breadcrumbs: false },
    { id: 'work-orders', title: 'menu.workOrders', type: 'item', url: '/work-orders', icon: icons.workOrders, breadcrumbs: false },
    {
      id: 'work-orders-tasks',
      title: 'menu.workOrderTasks',
      type: 'item',
      url: '/work-orders/tasks',
      icon: icons.workOrders,
      breadcrumbs: false
    },
    { id: 'fleet', title: 'menu.fleet', type: 'item', url: '/fleet', icon: icons.fleet, breadcrumbs: false },
    { id: 'calendar', title: 'menu.calendar', type: 'item', url: '/calendar', icon: icons.calendar, breadcrumbs: false },
    { id: 'map', title: 'menu.map', type: 'item', url: '/map', icon: icons.map, breadcrumbs: false },
    { id: 'customers', title: 'menu.customers', type: 'item', url: '/customers', icon: icons.customers, breadcrumbs: false },
    { id: 'maintenance', title: 'menu.maintenance', type: 'item', url: '/maintenance', icon: icons.maintenance, breadcrumbs: false },
    // WORKLOG-03 (VEK-145) — the account's work logs; its MENU_ACCESS row is the endpoint's role set.
    { id: 'work-logs', title: 'menu.workLogs', type: 'item', url: '/work-logs', icon: icons.workLogs, breadcrumbs: false },
    // COMM-02 (VEK-147, gate C5) — the operators' pay rates, read-only for the fleet manager. MENU-03 (VEK-179) — this
    // workspace placement is the fleet manager's alone; the owner column reaches the same page from `pay-rates-admin`
    // in the Administration group below. The two MENU_ACCESS rows are disjoint and their union is `GET /pay-rates`' set.
    { id: 'pay-rates', title: 'menu.payRates', type: 'item', url: '/pay-rates', icon: icons.payRates, breadcrumbs: false },
    // NAV-01 (VEK-93) — the former dashboard, drawn for the account-owner column (utils/roleGate MENU_ACCESS.analytics).
    { id: 'analytics', title: 'menu.analytics', type: 'item', url: '/analytics', icon: icons.analytics, breadcrumbs: false }
    // MENU-01 — Scanner is hidden from every seat (owner's "temporary hide", 2026-09-14); the
    // /scanner route stays. Restore by re-adding the item and a MENU_ACCESS row in utils/roleGate.
  ]
};

const admin: NavItemType = {
  id: 'admin',
  title: 'menu.administration',
  type: 'group',
  children: [
    { id: 'users', title: 'menu.users', type: 'item', url: '/users', icon: icons.users, breadcrumbs: false },
    // WH-01 (VEK-203) — the Warehouses list, in the slot the ONBOARD-01 (VEK-34) *Add warehouse* entry held; the form is
    // reached from the list's Add button and from the pending onboarding step. Own MENU_ACCESS row (utils/roleGate).
    { id: 'warehouses', title: 'menu.warehouses', type: 'item', url: '/warehouses', icon: icons.warehouse, breadcrumbs: false },
    { id: 'billing-config', title: 'menu.billingConfig', type: 'item', url: '/billing-config', icon: icons.settings, breadcrumbs: false },
    // MENU-03 (VEK-179) — the owner column's Pay rates entry, directly after Billing Configuration; same route, same
    // label as the workspace `pay-rates` entry the fleet manager sees. Its MENU_ACCESS row leaves out MY_ACCOUNTS,
    // which `GET /pay-rates` refuses although the group admits that seat.
    { id: 'pay-rates-admin', title: 'menu.payRates', type: 'item', url: '/pay-rates', icon: icons.payRates, breadcrumbs: false },
    // PAY-10 (VEK-107) — the account's payment-details profiles; no matrix row of its own (navigation spec): the
    // Administration group's seats see it, a financial manager reaches /payment-details by URL or the send dialog.
    {
      id: 'payment-details',
      title: 'menu.paymentDetails',
      type: 'item',
      url: '/payment-details',
      icon: icons.paymentDetails,
      breadcrumbs: false
    },
    {
      id: 'maintenance-config',
      title: 'menu.maintenanceConfig',
      type: 'item',
      url: '/maintenance-config',
      icon: icons.maintenanceConfig,
      breadcrumbs: false
    },
    {
      id: 'inspection-template',
      title: 'menu.inspectionTemplate',
      type: 'item',
      url: '/inspection-template',
      icon: icons.inspectionTemplate,
      breadcrumbs: false
    },
    {
      id: 'operational-schedule',
      title: 'menu.operationalSchedule',
      type: 'item',
      url: '/operational-schedule',
      icon: icons.calendar,
      breadcrumbs: false
    },
    { id: 'sensors', title: 'menu.sensors', type: 'item', url: '/sensors', icon: icons.sensors, breadcrumbs: false }
    // MENU-01 — Notifications left the menu for every seat; the header bell still opens /notifications.
  ]
};

const personal: NavItemType = {
  id: 'personal',
  title: 'menu.personal',
  type: 'group',
  children: [
    { id: 'profile', title: 'menu.profile', type: 'item', url: '/profile', icon: icons.users, breadcrumbs: false },
    // SUPPORT-01 (VEK-161) — every seat files and reads the account's support requests; its MENU_ACCESS row is
    // `GET /support-requests`' role set, all eight roles.
    { id: 'support', title: 'menu.support', type: 'item', url: '/support', icon: icons.support, breadcrumbs: false }
  ]
};

export { vektra, admin, personal };
